__turbopack_context__.v({
  "actionArea": "SpotDetail-module__VI5MIW__actionArea",
  "couponCard": "SpotDetail-module__VI5MIW__couponCard",
  "couponCardInner": "SpotDetail-module__VI5MIW__couponCardInner",
  "couponDescription": "SpotDetail-module__VI5MIW__couponDescription",
  "couponImage": "SpotDetail-module__VI5MIW__couponImage",
  "couponInfo": "SpotDetail-module__VI5MIW__couponInfo",
  "couponList": "SpotDetail-module__VI5MIW__couponList",
  "couponName": "SpotDetail-module__VI5MIW__couponName",
  "couponPeriod": "SpotDetail-module__VI5MIW__couponPeriod",
  "courseRow": "SpotDetail-module__VI5MIW__courseRow",
  "description": "SpotDetail-module__VI5MIW__description",
  "detailHeading": "SpotDetail-module__VI5MIW__detailHeading",
  "dot": "SpotDetail-module__VI5MIW__dot",
  "dotActive": "SpotDetail-module__VI5MIW__dotActive",
  "dots": "SpotDetail-module__VI5MIW__dots",
  "externalIcon": "SpotDetail-module__VI5MIW__externalIcon",
  "heroImage": "SpotDetail-module__VI5MIW__heroImage",
  "imageArea": "SpotDetail-module__VI5MIW__imageArea",
  "info": "SpotDetail-module__VI5MIW__info",
  "linkGroup": "SpotDetail-module__VI5MIW__linkGroup",
  "linkIcon": "SpotDetail-module__VI5MIW__linkIcon",
  "linkRow": "SpotDetail-module__VI5MIW__linkRow",
  "linkText": "SpotDetail-module__VI5MIW__linkText",
  "linkTextWithIcon": "SpotDetail-module__VI5MIW__linkTextWithIcon",
  "name": "SpotDetail-module__VI5MIW__name",
  "rightActions": "SpotDetail-module__VI5MIW__rightActions",
  "socialLink": "SpotDetail-module__VI5MIW__socialLink",
  "socialRow": "SpotDetail-module__VI5MIW__socialRow",
  "stampButton": "SpotDetail-module__VI5MIW__stampButton",
  "swiper": "SpotDetail-module__VI5MIW__swiper",
  "tagRow": "SpotDetail-module__VI5MIW__tagRow",
});
